module.exports = __webpack_public_path__ + "img/17.897b8f18.png";